module.exports = __webpack_public_path__ + "img/eeia-logo.a271fdf3.png";